(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class MobileMenu extends HTMLElement {
    constructor() {
      super();
      this.toggle = this.querySelector('.header__menu-toggle');
      this.menu = this.querySelector('.header__mobile-menu');

      if (this.toggle && this.menu) {
        this.toggle.addEventListener('click', () => this.handleToggle());
      }
    }

    handleToggle() {
      const isOpen = this.toggle.getAttribute('aria-expanded') === 'true';
      this.toggle.setAttribute('aria-expanded', String(!isOpen));
      this.menu.setAttribute('aria-hidden', String(isOpen));
      document.documentElement.style.overflow = isOpen ? '' : 'hidden';
    }
  }

  if (!customElements.get('mobile-menu')) {
    customElements.define('mobile-menu', MobileMenu);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductGallery extends HTMLElement {
    constructor() {
      super();
      this.images = this.querySelectorAll('.product-page__image');
      this.counter = this.querySelector('[data-current]');
      this.currentIndex = 0;
      this.submitBtn = this.querySelector('.product-page__add-to-cart');
      this.radioButtons = this.querySelectorAll('input[type="radio"][name="id"]');

      this.querySelector('[data-action="prev"]')?.addEventListener('click', () => this.navigate(-1));
      this.querySelector('[data-action="next"]')?.addEventListener('click', () => this.navigate(1));

      this.radioButtons.forEach(radio => {
        radio.addEventListener('change', () => this.updateButton(radio));
      });
    }

    navigate(direction) {
      this.images[this.currentIndex].classList.remove('product-page__image--active');
      this.currentIndex = (this.currentIndex + direction + this.images.length) % this.images.length;
      this.images[this.currentIndex].classList.add('product-page__image--active');
      if (this.counter) this.counter.textContent = this.currentIndex + 1;
    }

    updateButton(radio) {
      if (!this.submitBtn) return;
      const variantId = radio.value;
      const label = radio.nextElementSibling;
      const isDisabled = label && label.classList.contains('product-page__size-label--disabled');

      if (isDisabled) {
        this.submitBtn.disabled = true;
        this.submitBtn.textContent = this.submitBtn.dataset.soldOut || 'Épuisé';
      } else {
        this.submitBtn.disabled = false;
        this.submitBtn.textContent = this.submitBtn.dataset.addToCart || 'Ajouter au panier';
      }
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  const sizeGuideTrigger = document.getElementById('size-guide-trigger');
  const sizeGuideOverlay = document.getElementById('size-guide-overlay');
  const sizeGuideClose = document.getElementById('size-guide-close');

  if (sizeGuideTrigger && sizeGuideOverlay) {
    sizeGuideTrigger.addEventListener('click', () => sizeGuideOverlay.setAttribute('aria-hidden', 'false'));
    sizeGuideClose?.addEventListener('click', () => sizeGuideOverlay.setAttribute('aria-hidden', 'true'));
    sizeGuideOverlay.addEventListener('click', (e) => {
      if (e.target === sizeGuideOverlay) sizeGuideOverlay.setAttribute('aria-hidden', 'true');
    });
  }

  } catch(e) { console.error(e); }
})();
})();
